import { useConfirmDialog } from "../components/ConfirmDialog/ProvideConfirmDialog";

export default function useSavedResults() {
  const confirmationDialog = useConfirmDialog();
  const displaySavedAlert = () => {
    confirmationDialog.getConfirmation({
      closeWindow: true,
      title: "Din beräkning är sparad!",
      message: (
        <span>
          <span>
            OBS! Ett sparat resultat går inte att redigeras men du kan alltid
            spara ett nytt resultat.
          </span>
          <div>
            Du hittar alla dina sparade resultat{" "}
            <a class="" href={window?.wpObject?.saved_results_url}>
              här
            </a>
          </div>
        </span>
      ),
    });
  };
  return { displaySavedAlert };
}
